import { render, staticRenderFns } from "./cardPage.vue?vue&type=template&id=600ce80a&scoped=true&"
import script from "./cardPage.vue?vue&type=script&lang=js&"
export * from "./cardPage.vue?vue&type=script&lang=js&"
import style0 from "./cardPage.vue?vue&type=style&index=0&id=600ce80a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ce80a",
  null
  
)

export default component.exports